'use es6';

/* hs-eslint ignored failing-rules */
/* eslint-disable compat/compat */
import { useDispatch } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FETCH_GENERATED_LAYOUT_HUBL_SUCCESS, FETCH_GENERATED_LAYOUT_HUBL_FAILURE } from 'ContentEditorUI/redux/actions/actionTypes';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CopyAsHublFallbackAlert({
  hubl
}) {
  const dispatch = useDispatch();
  const copyCallback = () => {
    navigator.clipboard.writeText(hubl).then(() => {
      dispatch({
        type: FETCH_GENERATED_LAYOUT_HUBL_SUCCESS
      });
    }).catch(() => {
      dispatch({
        type: FETCH_GENERATED_LAYOUT_HUBL_FAILURE
      });
    }).finally(() => {
      FloatingAlertStore.removeAlert('copy-as-hubl-fallback');
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-around",
    minInlineSize: "190px",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.copyAsHubL.info.fallback"
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      size: 'small',
      onClick: copyCallback,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.copyAsHubL.info.copyButton"
      })
    })]
  });
}